import { ActivityPartAxis, ActivityWithAggregate } from '@/api/models/aggregate'
import { FrontActivityPart } from '@/store/slices/aggregateSlice/types/FrontActivityPart.type'
import { calculateDuration } from './calculateDuration'
import { mergeConstraints } from './mergeConstraints'
import { FrontActivityWithAggregate } from '../types/FrontActivityWithAggregate.type'

type HydrateMetaAndSortHelperOptions = {
  activityWithAggregate: ActivityWithAggregate
  axis?: string
  parentActivityPart?: FrontActivityPart<FrontActivityWithAggregate> | null
}

function hydrateMetaAndSortHelper({
  activityWithAggregate,
  axis = '',
  parentActivityPart = null,
}: HydrateMetaAndSortHelperOptions): FrontActivityWithAggregate {
  const children = activityWithAggregate.children

  if (children && children.length > 0) {
    children.sort((a, b) => a.order - b.order)

    for (const child of children) {
      const activityPart = child as FrontActivityPart<FrontActivityWithAggregate>

      activityPart.activityConstraint = mergeConstraints(parentActivityPart, activityPart)
      activityPart.optional = parentActivityPart?.optional === true ? true : activityPart.optional
      activityPart.scoreWeight = parentActivityPart?.scoreWeight === 0 ? 0 : activityPart.scoreWeight
      activityPart.axis = ((axis ? `${axis}/` : '') + activityPart.id) as ActivityPartAxis

      if (activityPart.childActivity) {
        activityPart.childActivity = hydrateMetaAndSortHelper({
          activityWithAggregate: activityPart.childActivity,
          axis: activityPart.axis,
          parentActivityPart: activityPart,
        })
      }
    }
  }

  return {
    ...activityWithAggregate,
    duration: calculateDuration(activityWithAggregate),
  } as FrontActivityWithAggregate
}

export function hydrateMetaAndSort(activityWithAggregate: ActivityWithAggregate): FrontActivityWithAggregate {
  return hydrateMetaAndSortHelper({ activityWithAggregate })
}
